import React from 'react';
import { useLocation } from 'react-router-dom';
import authStore from '../../store/authStore';

const Footer = () => {
  const location = useLocation();
  const { user } = authStore();
  const hiddenPaths = ['/login', '/register', '/verify-email', '/admin'];
  if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;

  return (
    <>
      {/* Desktop footer */}
      <footer className="hidden md:block bg-[#0F172A] text-slate-400 py-8 mt-auto" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-4 text-center text-sm space-y-3">
          <nav className="flex justify-center items-center gap-5 text-slate-300">
            <a href="/terms" className="hover:text-white transition" data-testid="footer-terms-link">Termini di Utilizzo</a>
            <span className="text-slate-600">·</span>
            <a href="/privacy" className="hover:text-white transition" data-testid="footer-privacy-link">Privacy</a>
            <span className="text-slate-600">·</span>
            <a href="mailto:support@makehome360.app" className="hover:text-white transition" data-testid="footer-support-link">Supporto</a>
          </nav>
          <p>&copy; {new Date().getFullYear()} MakeHome 360. Tutti i diritti riservati.</p>
        </div>
      </footer>
      {/* Mobile mini-footer: always visible for legal compliance */}
      <div className="md:hidden bg-[#0F172A] text-slate-400 py-4 pb-24 text-center text-xs" data-testid="site-footer-mobile">
        <nav className="flex justify-center items-center gap-3 text-slate-300 mb-2">
          <a href="/terms" className="hover:text-white transition" data-testid="footer-terms-link-mobile">Termini</a>
          <span className="text-slate-600">·</span>
          <a href="/privacy" className="hover:text-white transition" data-testid="footer-privacy-link-mobile">Privacy</a>
          <span className="text-slate-600">·</span>
          <a href="mailto:support@makehome360.app" className="hover:text-white transition">Supporto</a>
        </nav>
        <p className="text-slate-500">&copy; {new Date().getFullYear()} MakeHome 360</p>
      </div>
    </>
  );
};

export default Footer;
